module.exports = __webpack_public_path__ + "media/images/favorite-select-1bb25c95db0c7b7052a6a8593d777e65.svg";